import { useEffect, useMemo, useState, useRef } from 'react';
import { GetInvoiceData } from '../../store/invoiceAtom';

function InvoiceDiscountType({ defaultVal, onDiscountTypeSelect }) {
    const masterData = GetInvoiceData();
    const [selectedValue, setSelectedValue] = useState(defaultVal || 1);
    const isInitialized = useRef(false);
    
    const discountTypes = masterData?.discount_type || [];

    // Only run once on mount to set initial value
    useEffect(() => {
        if (discountTypes.length > 0 && !isInitialized.current) {
            const valueToUse = defaultVal || discountTypes[0].Discount_Type_Id;
            setSelectedValue(valueToUse);
            onDiscountTypeSelect(valueToUse);
            isInitialized.current = true;
        }
    }, [discountTypes]); // Removed selectedValue and onDiscountTypeSelect from dependencies

    // Separate effect to handle external defaultVal changes (like when editing)
    useEffect(() => {
        if (defaultVal && defaultVal !== selectedValue && isInitialized.current) {
            setSelectedValue(defaultVal);
        }
    }, [defaultVal]);

    const handleChange = (e) => {
        const newValue = Number(e.target.value);
        setSelectedValue(newValue);
        onDiscountTypeSelect(newValue);
    };

    const selectItems = useMemo(() => {
        if (!discountTypes.length) return [];
        
        return discountTypes.map((discount) => (
            <option key={discount.Discount_Type_Id} value={discount.Discount_Type_Id}>
                {discount.Discount_Type_Name}
            </option>
        ));
    }, [discountTypes]);

    return (
        <select 
            value={selectedValue} 
            onChange={handleChange}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
            {selectItems}
        </select>
    );
}

export default InvoiceDiscountType;